module.exports = __webpack_public_path__ + "static/media/forest-service.eefc4669.png";